import { GridItem, Tag, FormLabel, Box, Button as ButtonChakra, Grid, 
  InputGroup,InputLeftAddon,Stack,
  IconButton, Input, Select, Textarea, useDisclosure } from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEstados, createEstados, updateNotes, deleteNotes } from "../redux/estados/estado_actions";

import { useMediaQuery } from "@chakra-ui/react"

import { FloatButton } from 'antd';

import { deleteEstados, updateEstados } from "../redux/estados/estado_actions"

import DataTable from 'react-data-table-component';

import { Table, Button, Icon } from "semantic-ui-react";

import { Wrap, WrapItem } from '@chakra-ui/react'
import { Center, Square, Circle } from '@chakra-ui/react'

import {toast, Toaster } from 'react-hot-toast';

import EstadoCard from "../components/Estados/EstadoCard/EstadoCard";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
} from "@chakra-ui/react";

export default function Estadospage()
{
    const dispatch = useDispatch()
    const {loading, error, dataestado} = useSelector((state)=>state.estadoReducer)
    const [estados, setEstados] = useState([])
    
    const { isOpen, onOpen, onClose } = useDisclosure()
    const modalEdit = useDisclosure()

    const initialRef = useRef(null)
    const finalRef = useRef(null)
    const [descripcion, setDescripcion] = useState("")

    const [tempDescripcion, setDescripcion2] = useState(descripcion)
    const [tempID,setId] = useState();     

    useEffect(()=>{
        console.log(" useEfect Estadopage");
        
        dispatch(getEstados())
    }, [])

    useEffect(()=>{
        setEstados(dataestado);        
        console.log(" Data Estados 2 => ",dataestado);
        
    }, [dataestado])

    const [isMobile] = useMediaQuery("(max-width: 768px)") 

    const createEstado = ()=>{
        setDescripcion('');
        dispatch(createEstados({descripcion}))
        onClose()
    }

    const updateEstado = ()=>{
      dispatch(updateEstados(tempID, {descripcion: tempDescripcion}))
      modalEdit.onClose()
  }

    const columns = [
      {
        name: "Acciones",width:"100px",
        selector: (row) => {
          return (
            <Actions
              row={row}
              id={row.id}
              setId={setId}
              modalEdit={modalEdit}
              setDescripcion2={setDescripcion2}
            />
          );
        },
      }, 
      {
        name: 'Descripción', selector: row => row.descripcion,
      },      
    ];

    const paginationComponentOptions = {
      rowsPerPageText: 'Filas por página',
      rangeSeparatorText: 'de',
      selectAllRowsItem: true,
      selectAllRowsItemText: 'Todos',
    };



    return (
    <>
      <FloatButton icon={<AddIcon fontSize={20} />} onClick={onOpen} type="primary" />;
      
      <Box mt={20} padding={8}> Estados        
          <DataTable
            title="Estados"
			      columns={columns}
			      data={dataestado}
            pagination
            paginationComponentOptions={paginationComponentOptions}
		      />

          <Grid gap={10} w={"100%"} margin={"auto"} gridTemplateColumns="repeat(4, 1fr)">
              {/* {estados?.map((el)=><EstadoCard {...el}/>)} */}
          </Grid>

          <>
        {/*<IconButton boxShadow={"rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;"} position={"fixed"} w={"100px"} h={"100px"} bg={"#5b9cf2"} bottom={0} right={0} margin={16} icon={<AddIcon fontSize={30} />} 
        onClick={onOpen}></IconButton>*/}
        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpen}
          onClose={onClose}
        >
          <ModalOverlay />
          <ModalContent  maxW={isMobile ? "100%" : "40%"}>
            <ModalHeader>Crear nuevo estado</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>  
            <Stack spacing={4}>
                      <InputGroup>
                          <InputLeftAddon width={150}>Descripción</InputLeftAddon>
                          <Input value={descripcion}m placeholder="Introduce la descripción" onChange={(e)=>setDescripcion(e.target.value)}></Input>
                      </InputGroup>
                </Stack>
            </ModalBody>

            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={createEstado}>              
                Crear
              </Button>
              <Button onClick={onClose}>Cancelar</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        </>

        {/* Modal Editor */}
        <>         
        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          closeOnOverlayClick={false}
          isOpen={modalEdit.isOpen} onClose={modalEdit.onClose}
        >
          <ModalOverlay />
          <ModalContent  maxW={isMobile ? "100%" : "40%"}>
              <ModalHeader>Editar Destino</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Stack spacing={4}>
                      <InputGroup>
                          <InputLeftAddon width={150}>ID</InputLeftAddon>
                          <Input isDisabled value={tempID} onChange={(e)=>setId(e.target.value)}></Input>
                      </InputGroup>                  
                      <InputGroup>
                          <InputLeftAddon width={150}>Descripción</InputLeftAddon>
                          <Input value={tempDescripcion}m placeholder="Introduce la descripción" onChange={(e)=>setDescripcion2(e.target.value)}></Input>
                      </InputGroup>
                </Stack>               
              </ModalBody>
              <ModalFooter>
                <ButtonChakra olorScheme="blue" mr={3} onClick={updateEstado}> 
                  Guardar
                </ButtonChakra> 
                <ButtonChakra onClick={modalEdit.onClose}>Cerrar</ButtonChakra>
              </ModalFooter>              
            </ModalContent>

          </Modal>
          
        </>
        <Toaster />
    </Box>
    </>
    )
}

function Actions(props) {
  const { row, modalEdit,
        id, 
        setId,
        setDescripcion2,
       } = props;

  return (
    <Table.Cell textAlign="right">
        <Icon name="pencil" onClick={() => {
                setId(id);
                setDescripcion2(row.descripcion);
                modalEdit.onOpen();
          }}/> 
      
    </Table.Cell>
  );
}